<template>
  <div class="index-order container-md">
    <div class="title-box">
      <div class="left-box">
         <div class="title">我的订单</div>
      </div>
      <div class="right-box">
        <router-link :to="{path: '/orders'}" class="all-order-btn" v-if="orderList.length">
          查看全部订单
          <span class="icon" ></span>
        </router-link>
      </div>
    </div>
    <div class="content" :class="{'null-list': !orderList.length}">
      <div class="order-list" v-if="orderList.length">
        <div class="order-item" :class="{'show-user-phone': item.peer_user && item.peer_user.mobile_phone}" v-for="item in orderList" :key="item.id">
          <!-- 顾客新订单标签 -->
          <img v-if="item.is_new_order" class="customer-new-tag" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-order-new.png" alt="">
          <div class="item-left">
            <div class="item-id-box">{{item.user_order_id}}</div>
            <div class="item-goods-name">{{item.product_name}}</div>
          </div>
          <div class="item-right-box">
            <div v-if="item.peer_user && item.peer_user.mobile_phone" class="user-phone">
              <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-phone-small.png" alt="">
              <div class="user-phone-label">顾客联系方式：</div>
              <base-text-copy :text="item.peer_user.mobile_phone"></base-text-copy>
            </div>
            <!-- 占位使用，用于和左边对齐 -->
            <div class="top-row"></div>
            <div class="bottom-row">
              <div class="item-applicant-name-list">
                <div class="item-applicant-item-name"
                  v-for="applicanItem in item.applicant.length > 3 ? item.applicant.slice(0, 3) : item.applicant"
                  :key="applicanItem.applicant_name"
                >{{applicanItem.applicant_name}}</div>
                <div class="item-applicant-icon">
                  <div class="item-all-applicant-box">
                    <div class="applicant-item" v-for="applicanItem in item.applicant" :key="applicanItem.order_applicant_id">
                      <div class="name">{{applicanItem.applicant_name}}</div>
                      <div class="identity">{{applicanItem.identity}}</div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="item-handle-box">
                <div class="order-status">
                  <img class="order-status-icon" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-order-status.png" />
                  {{$maps.ORDER_STATUS[item.order_status]}}
                </div>
                <div class="order-btn-box">
                  <button class="s-btn btn-blue" @click="goBuyingForMta($event, item)" v-if="item.order_status == 1">上传资料</button>
                  <button class="s-btn btn-blue" @click="goBuyingForMta($event, item)" v-if="item.order_status == 2">填写申请表</button>
                  <button class="s-btn btn-blue" @click="goBuyingForMta($event, item)" v-if="item.order_status == 3">立即支付</button>
                  <button class="s-btn btn-blue" @click="goBuyingForMta($event, item)" v-if="item.order_status == 10">选择赴馆日期</button>
                  <button class="s-btn btn-blue" @click="goOrderDetail($event, item)" v-if="item.order_status > 3 && item.order_status !== 10">查看订单</button>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="order-null-list" v-else>
        <img class="icon" src="https://o.666visa.cn/static/ssqpeer/homepage/order-null-img.png" alt="">
        <span class="text">暂无订单{{is_palmyou ? '' : '，您还有首单优惠未使用哦'}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapState } from 'vuex';
import Http from '../../../libs/http';
import BaseTextCopy from '@/components/common/base-text-copy.vue';

export default {
  name: 'index-order',
  components: {
    BaseTextCopy,
  },
  data() {
    return {
      orderList: [],
    };
  },
  created() {
    Http.post('/latest_order_query', {}).then((res) => {
      this.orderList = res.data;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  computed: {
    ...mapState('user', [
      'userInfo',
    ]),
    is_palmyou() {
      return this.userInfo.is_palmyou;
    },
  },
  activated() {
    Http.post('/latest_order_query', {}).then((res) => {
      this.orderList = res.data;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  methods: {
    // 根据不同状态到下单界面
    goBuyingForMta(e, item) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (item.order_status === 1) {
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 2) {
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 3) {
        this.$router.push({
          name: 'orderComfirm',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 10) {
        this.$router.push({
          name: 'waittingForChooseInterviewTime',
          params: {
            oid: item.user_order_id,
          },
        });
      }
    },
    // 到订单详细界面
    goOrderDetail(e, order) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({
        name: 'orderDetail',
        params: { oid: order.user_order_id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-order{
  margin-bottom: 42px;
  .title-box{
    display: flex;
    align-items: center;
    .left-box{
      flex-grow: 1;
      .title{
        font-size: 28px;
        line-height: 40px;
        color: #2F333D;
        font-weight: 600;
        position: relative;
        z-index: 1;
        &::after{
          content: "";
          width:96px;
          height:8px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
          opacity:0.6;
          position: absolute;
          bottom: 2px;
          left: 0;
          z-index: -1;
        }
      }
    }
    .right-box{
      flex-shrink: 0;
      .all-order-btn{
        cursor: pointer;
        font-size: 14px;
        line-height: 20px;
        color: #5F666E;
        display: flex;
        align-items: center;
        .icon{
          width: 12px;
          height: 12px;
          margin-left: 4px;
          background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-right-gray-1.png) no-repeat;
          background-size: 100% 100%;
          display: inline-block;
        }
        &:hover{
          color: #599FFF;
          .icon{
            background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-right-blue.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .content{
    margin-top: 16px;
    background: #F3F6F9;
    border-radius:4px;
    padding: 20px 20px 20px 28px;
    &.null-list{
      background: #FAFBFC;
    }
    .order-list{
      margin-bottom: -12px;
      .order-item{
        position: relative;
        box-shadow:0px 2px 6px 0px rgba(47,51,61,0.06);
        background: #fff;
        border-radius:2px;
        height: 83px;
        margin-bottom: 12px;
        display: flex;
        &::after{
          content: '';
          position: absolute;
          width: 8px;
          height: 54px;
          background:linear-gradient(180deg,rgba(89,159,255,1) 0%,rgba(156,196,255,1) 100%);
          border-radius:2px;
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
        }
        &.show-user-phone{
          height: 90px;
        }
        .customer-new-tag{
          width: 65px;
          height: 40px;
          position: absolute;
          top: -14px;
          left: -11px;
        }
        .item-left{
          flex-shrink: 0;
          width: 462px;
          box-shadow:2px 0px 4px 0px rgba(47,51,61,0.06);
          padding: 0 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          .item-id-box{
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #91999F;
            line-height: 1;
          }
          .item-goods-name{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #2F333D;
            font-size: 16px;
            line-height: 36px;
            font-weight: 600;
            height: 36px;
            width: 100%;
          }
        }
        .item-right-box{
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 0 20px 0 12px;

          .user-phone{
            position: absolute;
            right: 0;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #5F666E;
            font-size: 12px;
            line-height: 1;
            width: 300px;
            height: 24px;
            background: linear-gradient( 270deg, rgba(89,159,255,0.08) 0%, rgba(89,159,255,0) 100%);
            border: 2px solid #FFFFFF;
            padding: 0 20px;
            .icon{
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }
            .user-phone-user{
              cursor: pointer;
              &:hover{
                color: #5E9BE2;
              }
            }
          }
          .top-row{
            height: 14px;
          }

          .bottom-row{
            width: 100%;
            height: 36px;
            display: flex;
            align-items: center;
            .item-applicant-name-list{
              flex-grow: 1;
              padding: 0 12px;
              display: flex;
              align-items: center;
              .item-applicant-item-name{
                margin-right: 12px;
                font-size: 14px;
                color: #5F666E;
                max-width: 56px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .item-applicant-icon{
                width: 16px;
                height: 16px;
                cursor: pointer;
                background: url(https://o.666visa.cn/static/ssqpeer/homepage/order-more-applicant-gray.png) no-repeat;
                background-size: 100% 100%;
                position: relative;
                &:hover{
                  background: url(https://o.666visa.cn/static/ssqpeer/homepage/order-more-applicant.png) no-repeat;
                  background-size: 100% 100%;
                  .item-all-applicant-box{
                    display: block;
                  }
                }

                .item-all-applicant-box{
                  display: none;
                  margin-top: 15px;
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  transform: translateX(-50%);
                  background: #fff;
                  border: 1px solid #E9EEF2;
                  padding: 16px 20px;
                  box-shadow:0px 4px 8px 0px rgba(47,51,61,0.06);
                  border-radius: 4px;
                  z-index: 5;
                  max-height: 400px;
                  overflow: auto;

                  &::before {
                    content: '';
                    position: absolute;
                    top: -9px;
                    left: 50%;
                    transform: translate(-50%, 0);
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 10px solid #fff;
                    z-index: 2;
                  }
                  &::after {
                    content: '';
                    position: absolute;
                    top: -10px;
                    left: 50%;
                    transform: translate(-50%, 0);
                    border-left: 11px solid transparent;
                    border-right: 11px solid transparent;
                    border-bottom: 11px solid #E9EEF2;
                    z-index: 1;
                  }
                  .applicant-item{
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    &:last-child{
                      margin-bottom: 0;
                    }
                    .name{
                      flex-shrink: 0;
                      color: #2F333D;
                      font-size: 14px;
                      line-height: 20px;
                      width: 58px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .identity{
                      width: 62px;
                      flex-shrink: 0;
                      margin-left: 8px;
                      color: #91999F;
                      font-size: 12px;
                      line-height: 16px;
                    }
                  }

                }
              }

            }
            .item-handle-box{
              flex-shrink: 0;
              display: flex;
              align-items: center;
              padding-right: 20px;
              .order-status{
                display: flex;
                align-items: center;
                color: #FF6464;
                font-size: 14px;
                .order-status-icon{
                  width: 20px;
                  height: 20px;
                  margin-right: 2px;
                }
              }
              .order-btn-box{
                margin-left: 16px;
              }
            }
          }

        }

      }
    }
    .order-null-list{
      display: flex;
      align-items: center;
      justify-content: center;
      .icon{
        width: 100px;
        height: 70px;
        margin-right: 20px;
      }
      .text{
        font-size: 20px;
        color: #91999F;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-order.vue